import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PhysicalCardsRoutingModule } from './physical-cards-routing.module';
import { PhysicalCardsListComponent } from './physical-cards-list/physical-cards-list.component';
import { SharedModule } from '../../../../shared/shared.module';
import { PhysicalCardsComponent } from './physical-cards/physical-cards.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    PhysicalCardsRoutingModule
  ],
  declarations: [
    PhysicalCardsComponent,
    PhysicalCardsListComponent
  ]
})
export class PhysicalCardsModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/physical-cards/physical-cards.module.ts